import React from 'react';
import { FormattedMessage } from 'react-intl';

export const priceOptions = [
  { value: 'per_item', label: <FormattedMessage id="hosting.price_options.per_item" defaultMessage="per item"/> },
  { value: 'per_person', label: <FormattedMessage id="hosting.price_options.per_person" defaultMessage="per person"/> },
  { value: 'per_hour', label: <FormattedMessage id="hosting.price_options.per_hour" defaultMessage="per hour"/> },
  { value: 'flat_fee', label: <FormattedMessage id="hosting.price_options.flat_fee" defaultMessage="flat fee"/> }
];

export const inventoryErrors = {
  tax_not_configurable: 'Peerspace is responsible for collecting and remitting taxes in your state.'
};
